import React from 'react';
import ReferralInfo from '../components/sections/ReferralInfo';
import TeamTree from '../components/sections/TeamTree';

export default function Team() {
  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title"><span className="title-accent">⚑</span> Team</h2>
          <div className="page-subtitle">Referrals · 20-level team overview</div>
        </div>
      </div>

      <div className="mb-4">
        <ReferralInfo />
      </div>

      <TeamTree />
    </div>
  );
}
